<template>
  <div class="app text-dark" style="font-family: 'Poppins';" >
    <!-- <Navbar/> -->
      <div style="scroll-behavior: smooth; ">
        <main>
          <div  class="p-0" style="height: 100% !important; width: 100%; overflow: hidden; position: fixed; ">
            <transition name="fade" mode="out-in">
              <router-view style="height: 100% !important; overflow-y: auto; " id="scroll-container"></router-view>
            </transition>
            <font-awesome-icon @click="scrollToTop" class="hover" style="z-index: 1000; position: absolute; bottom: 90px; right: 30px; font-size: 40px" :icon="['fas', 'chevron-up']"/>
            
            <b-row class="m-0 pt-3 px-3 justify-content-between" v-if="!checkShopMode && !$route.query.tableId" style="position: absolute; top: 0px; left: 0px; right: 0;">
              <div @click="changeRoute()" class="p-0" style="width: 120px; ">
                <b-row class="m-0">
                  <transition name="fade" mode="out-in">
                    <font-awesome-icon v-if="$route.name != 'Home'" class="text-dark mt-2" icon="chevron-left" style="font-size: 40px; cursor: pointer; z-index: 1000" />
                  </transition>
                  <div style="z-index: 3000">
                    <b-img-lazy  :src="require(`@/assets/logos/eatDoradoAppIcon.png`)" style="max-height: 50px; cursor: pointer;" fluid alt="eatDorado Logo"></b-img-lazy>
                  </div>
                </b-row>
              </div>
              <transition name="fade" mode="out-in">
                <h4 class="mt-3" v-if="adressData && $route.name == 'Restaurants'">{{ adressData.locality }}</h4>
                <h4 class="mt-3" style="font-size: 20px; transform: rotate(-5deg);" v-if="$route.name == 'Bestellung'">#supportyourlocals</h4>
              </transition>
              <span>&nbsp;</span>
              <!-- <span class="text-right m-0 mr-3 p-0" style="font-size:35px;cursor:pointer; z-index: 3000" @click="openNav()">&#9776;</span>          -->
            </b-row>

            <b-row class="m-0 pt-3 px-3 justify-content-between" v-if="checkShopMode ||$route.query.tableId" style="position: absolute; top: 0px; left: 0px; right: 0;">
              <div class="">
                <b-img-lazy  :src="require(`@/assets/logos/eatDoradoAppIcon.png`)" style="max-height: 50px; z-index: 3000" fluid alt="eatDorado Logo"></b-img-lazy>
              </div>
              <transition name="fade" mode="out-in">
                <!-- <h3 class="mt-3" v-if="restaurant" style="z-index: 1">{{ restaurant.title.substring(0, 23) }}</h3> -->
                <h3 class="mt-3" v-if="restaurant" style="z-index: 1"> </h3>
              </transition>
              <span>&nbsp;</span>
              <!-- <span class="text-right mr-3 m-0" style="font-size:35px;cursor:pointer; z-index: 3000" @click="openNav()">&#9776;</span>          -->
            </b-row>

            <div class="linear-warning w-100" style="z-index: -1; height: 150px; position: absolute; top: 0"></div>
            <div class="triangle-top linear-warning w-100"></div>
            <div class="linear-warning w-100" style="z-index: -1; height: 250px; position: absolute; bottom: -10px"></div>
            <div class="triangle-bottom linear-warning w-100"></div>

            <div  id="mySidenav" class="sidenav shadow">
              <b-row class="m-0 mb-3 justify-content-center">
                <b-img-lazy :src="require(`@/assets/logos/eatDoradoAppIcon.png`)" style="max-height: 50px" fluid alt="eatDorado Logo"></b-img-lazy>
              </b-row>
              
              <span href="javascript:void(0)" class="closebtn" @click="closeNav()">&times;</span>
              <span v-if="$route.name != 'Home'" @click="goTo('/')">Home</span>
              <hr>
              <span v-if="!loggedIn" @click="goTo('/login')">Anmelden</span>
              <span v-if="loggedIn" @click="goTo('/profil')">Profil</span>
              <span v-if="loggedIn" @click="$store.dispatch('logout')">Abmelden</span>
              <hr>
              <span @click="goTo('/impressum')">Impressum</span>
              <span @click="goTo('/datenschutz')">Datenschutz</span>
            </div>

          </div>
        </main>
      </div>

        
    <b-modal id="loginModal" size="" centered v-model="loginModal" title="BootstrapVue" hide-footer hide-header>
      <div class="bg-white" style="border-radius: 10px; transition: all .5s;">
        <b-row class="m-0 linear-warning pt-3 pr-3 justify-content-end" style="border-top-left-radius: 10px; border-top-right-radius: 10px;">
          <font-awesome-icon @click="loginModal = false" style="font-size: 37px; cursor: pointer" :icon="['fas', 'times']"/>
        </b-row>
        <b-row class="m-0 linear-warning justify-content-center" >
        <h2 class="text-center text-dark" >mein eatDorado</h2>
        </b-row>
        <b-row class="m-0 pt-3 linear-warning triangle-modal justify-content-between">
          
        </b-row>
        <b-row class="m-0 justify-content-around" style="position: relative; top: -4vh">
          <b-form @submit.prevent="onSubmit" style="width: 90%">
            <b-form-group
              v-if="registerActive"
              id="input-group-1"
              label="Name:"
              label-for="input-1"
             
            >
              <b-form-input
                :state="!form.name ? false : true"
                id="input-1"
                v-model="form.name"
                type="text"
                placeholder="Name eingeben"
                required
              ></b-form-input>
            </b-form-group>
            <b-form-group
              id="input-group-2"
              label="E-Mail-Addresse:"
              label-for="input-2"
            >
              <b-form-input
                :state="!form.email ? false : true"
                id="input-2"
                v-model="form.email"
                type="email"
                placeholder="E-Mail eingeben"
                required
              ></b-form-input>
            </b-form-group>
          <b-form-group id="input-group-3" label="Passwort" label-for="input-3">
            <b-form-input
              :state="!form.password ? false : true"
              id="input-3"
              v-model="form.password"
              placeholder="Passwort eingeben..."
              type="password"
              required
            ></b-form-input>
          </b-form-group>
          <b-form-group v-if="registerActive" id="input-group-4" label="Passwort wiederholen" label-for="input-4">
            <b-form-input
              :state="!form.passwordRepeat ? false : true"
              id="input-4"
              v-model="form.passwordRepeat"
              placeholder="Passwort wiederholen..."
              type="password"
              required
            ></b-form-input>
          </b-form-group>
          <b-form-group v-if="registerActive" id="input-group-5">
            <b-form-checkbox-group
              :state="!form.checked > 0 ? false : true"
              v-model="form.checked"
              id="checkboxes-4"
              required
            >
              <b-form-checkbox value="me"><a href="/datenschutz" target="_blank">Datenschutz</a> gelesen und akzeptiert</b-form-checkbox>
            </b-form-checkbox-group>
          </b-form-group>
          <b-button type="submit" style="width: 100%" size="md" variant="dark">{{ registerActive ? 'registrieren' : 'anmelden' }}</b-button>
          <b-button style="width: 100%" size="md" class="mt-3" variant="outline-dark" @click="registerActive = !registerActive">{{ registerActive ? 'einloggen' : 'Account erstellen' }} </b-button>
          </b-form>
          
        </b-row>
        
      </div>
    </b-modal>

  </div>
</template>

<script>
import coreData from '@/mixins/coreDataMixin'
// import Navbar from '@/components/Navbar'
import { mixin as clickaway } from 'vue-clickaway';
import update from '@/mixins/update'

import smoothscroll from 'smoothscroll-polyfill';
export default {
  name: 'MainContainer',
  mixins: [coreData, update], clickaway,
  components: {
    // Navbar,
  },
  data() {
    return {
      showDetail: false,
      form: {},
      loginModal: false,
      registerActive: false,
    }
  },
  props: {

  },
  mounted(){
    smoothscroll.polyfill();
  },
  computed: {
    restaurant(){
      return this.$store.getters.restaurant
    },
    darkMode(){
      return this.$store.getters.darkMode
    },
    checkShopMode(){
      if(this.$route.params.id){
        if(!this.restaurant) return false
        if(this.$route.params.id == this.restaurant.url){
          return true
        }
      }
      return false
    }
  },
  methods: {
    goTo(link){
      this.closeNav()
      this.$router.push(link).catch(() => {})
    },
    openNav() {
      document.getElementById("mySidenav").style.width = "220px";
    },
    closeNav() {
      document.getElementById("mySidenav").style.width = "0";
    },
    changeRoute(){
      if(this.checkShopMode) return 
      if(this.$route.name == 'Restaurant'){
        this.$router.push('/restaurants').catch(() => {})
      }else{
        this.$router.push('/').catch(() => {})
      }
      
    }
     
  }
}
</script>

<style lang="scss">
.modal-backdrop {
  opacity: .4 !important;
}

.triangle-top {
    z-index: -1;
    position: absolute;
    top: 150px;
    height: 10vh;
    clip-path: polygon(0 0,0 100%,100% 0,100% 0);
    -webkit-clip-path: polygon(0 0,100% 0,100% 0,0 100%);
  }

  .triangle-bottom {
    z-index: -1;
    position: absolute;
    bottom: 239px;
    height: 10vh;
    width: 100%;
    clip-path: polygon(100% 0, 0 100%, 100% 100%);
    -webkit-clip-path: polygon(100% 0, 0 100%, 100% 100%);
  }

// .app {
//   background-color: white;
//   min-height: 100vh;
//   margin-top: -10px;
// }

</style>

<style lang="scss" >

.shake {
  animation: shake 1.0s;
  animation-iteration-count: infinite;
}

//Chrome, Safari, Opera
body ::-webkit-scrollbar { width: 0 !important }  

//Firefox
body { overflow: -moz-scrollbars-none; }

//Internet Explorer, Edge
body { -ms-overflow-style: none; }

@keyframes shake {
  0% { transform: translate(1px, 1px) rotate(0deg); }
  10% { transform: translate(-1px, -2px) rotate(-1deg); }
  20% { transform: translate(-3px, 0px) rotate(1deg); }
  30% { transform: translate(3px, 2px) rotate(0deg); }
  40% { transform: translate(1px, -1px) rotate(1deg); }
  50% { transform: translate(-1px, 2px) rotate(-1deg); }
  60% { transform: translate(-3px, 1px) rotate(0deg); }
  70% { transform: translate(3px, 1px) rotate(-1deg); }
  80% { transform: translate(-1px, -1px) rotate(1deg); }
  90% { transform: translate(1px, 2px) rotate(0deg); }
  100% { transform: translate(1px, -2px) rotate(-1deg); }
}

.sidenav {
  height: 100%;
  width: 0;
  position: fixed;
  z-index: 3000;
  top: 0;
  right: 0;
  background-color: #fff;
  overflow-x: hidden;
  transition: 0.3s;
  padding-top: 60px;
}

.sidenav span {
  padding: 8px 8px 8px 32px;
  text-decoration: none;
  font-size: 25px;
  color: #353535;
  display: block;
  transition: 0.3s;
  cursor: pointer;
}

.sidenav span:hover {
  color: rgb(255,193,7) !important;
}

.sidenav .closebtn {
  position: absolute;
  top: 0;
  right: 20px;
  font-size: 40px;
  margin-left: 50px;
}

@media screen and (max-height: 450px) {
  .sidenav {padding-top: 15px;}
  .sidenav a {font-size: 18px;}
}

  .order-button {
    border-bottom-left-radius: 20px;
    border-top-right-radius: 20px;
    bottom: 0;
    left: 0;
    width: 100%;
    padding-left: 10px;
    padding-right: 10px;
    min-height: 50px;
  }
  .forbidden {
   cursor: not-allowed;
  }
  :focus{
      outline: none;
  }
  .collapsed > .when-open,
.not-collapsed > .when-closed {
  display: none;
}

.modal-backdrop {
  width: 100% !important;
  height: 100% !important
}

.scale {
  transform: scale(0.9) !important;
  transform-origin: 0px 0px 0px 0px 0px !important;
  width: 2000px;
  max-width: 110vw;
}

.hover {

  cursor: pointer;
}
.showcase-lite {
  border-radius: 8px;
  border-left-width: 4px;
  border-left-style: solid;
}

  .dropshadow {
    box-shadow: 1px 1px 1px rgba(255,255,255,0.05), 1px 1px 5px rgba(0,0,0, .5) !important
  }

  .overlay {
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: black;
    opacity: .5;
    border-bottom-left-radius: 100px;
    border-bottom-right-radius: 100px;
  }


.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.slide-leave-active,
.slide-enter-active {
  transition: .5s;
}
.slide-enter {
  transform: translate(100%, 0);
}
.slide-leave-to {
  transform: translate(-100%, 0);
}

.rotate-leave-active,
.rotate-enter-active {
  transition: .5s;
}
.rotate-enter {
  transform: rotate(-180deg);
}
.rotate-leave-to {
  transform: rotate(180deg);
}

.slideIn-leave-active,
.slideIn-enter-active {
  transition: .3s;
}
.slideIn-enter {
  transform: translate(100%, 0);
}
.slideIn-leave-to {
  transform: translate(100%, 0);
}

.slideLe-leave-active,
.slideLe-enter-active {
  transition: .3s;
}
.slideLe-enter {
  transform: translate(-100%, 0);
}
.slideLe-leave-to {
  transform: translate(-100%, 0);
}

.slideRi-leave-active,
.slideRi-enter-active {
  transition: .3s;
}
.slideRi-enter {
  transform: translate(100%, 0);
}
.slideRi-leave-to {
  transform: translate(100%, 0);
}

.sliderev-leave-active,
.sliderev-enter-active {
  transition: .5s;
}
.sliderev-enter {
  transform: translate(-100%, 0);
}
.sliderev-leave-to {
  transform: translate(100%, 0);
}

  .custom-nav {
    cursor: pointer;
    .focus {
      outline: 0;
    }
  }

  .custom-nav:hover{
    color: rgb(255,193,7) !important;
  }

  .modal-body {
    background-color: rgba(0,0,0,.0001) !important;
    border: none;
  }
  .modal-content {
    background-color: rgba(0,0,0,.0001) !important;
    border: none;
  }


  .linear-danger {
    background: linear-gradient(60deg,#ef5350,#e53935);
  }

  .linear-info {
    background: linear-gradient(60deg,#26c6da,#00acc1);
  }

  .linear-success {
    transition: all .25s ease;
    background: linear-gradient(60deg,#66bb6a,#43a047);
  }

  .linear-dark {
    background: linear-gradient(60deg,#343a40,rgb(61, 59, 59));
  }

  .linear-warning {
    transition: all .25s ease;
    background: rgb(255,193,7);
    background: linear-gradient(90deg, rgba(255,193,7,1) 0%, rgba(253,255,51,1) 100%);
  }

  // .linear-warning {
  //   background: #ff5622ce;
  //   background: linear-gradient(90deg, #FF5722 0%, #e97528 100%);
  // }

  .linear-primary {
    background: linear-gradient(60deg,#3b8fd3,#1755da);
  }


  // .center {
  //   margin: 0;
  //   position: absolute;
  //   top: 50%;
  //   left: 50%;
  //   transform: translate(-50%, -50%);
  // }

  .btn-custom {
    border-radius: 10px !important;
    border: none !important;
    box-shadow: -2px -2px 5px rgba(255,255,255,0.05), 2px 2px 5px rgba(0,0,0, .5) !important
  }

</style>